enum EnumEstadoCivil {
  SOLTEIRO = 'Solteiro',
  CASADO = 'Casado',
  SEPARADO = 'Separado',
  DIVORCIADO = 'Divorciado',
  VIUVO = 'Viúvo',
}

export default EnumEstadoCivil;
